<template>
  <div class="">
    <van-action-sheet v-model="show" title="Giỏ hàng">
      <div class="content" v-if="shopData.product_id">
        <div class="page_pay_info_list">
          <div class="page_pay_info_img">
            <img :src="shopData.product_img" alt="" />
          </div>
          <div class="page_pay_info_list_text">
            <div class="page_pay_info_list_top">
              {{ shopData.product_name }}
            </div>
            <div class="page_pay_info_list_bottom">
              {{ shopData.need_pay || 0 }} VND
            </div>
          </div>
          <div class="page_pay_info_right">
            <div class="page_pay_info_right_bg">
              <div>x1</div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="noData">Đơn hàng đang trống</div>
      <div class="model_bottom">
        <div class="model_bottom_content">
          <div class="page_bottom_left">
            <div class="page_bottom_money">
              <div class="page_bottom_money_top">Tổng tiền:</div>
              <div class="page_bottom_money_bottom">
                {{ shopData.need_pay || 0 }} VND
              </div>
            </div>
          </div>
          <div class="page_bottom_right">
            <el-button
              type="danger"
              class="page_bottom_btn"
              @click="handleClick"
              :disabled="!shopData.need_pay"
              >Tiếp tục <i class="el-icon-arrow-right"></i>
            </el-button>
          </div>
        </div>
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
export default {
  name: "",
  mixins: [],
  components: {},
  props: {},
  data() {
    return {
      show: false,
      shopData: {},
      userInfo: {},
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    handleClick() {
      this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
      this.show = false;
      if (this.userInfo?.cp_roleid) {
        this.$parent.openConfirmInfo();
      } else {
        this.$parent.scrollToModules("top");
        this.$parent.isLoginErrorMudules();
        this.$message.error("Thông tin nhân vật không hợp lệ");
      }
    },
  },
};
</script>

<style scoped lang="scss">
.van-action-sheet {
  max-height: 90%;
}
.van-action-sheet__header {
  box-shadow: rgba(0, 0, 0, 0.08) 0px 4px 12px 0px;
}
.content {
  padding: 16px 16px 0;
  height: 50vh;
  overflow: auto;
}
.noData {
  padding-inline-start: 24px;
  padding-inline-end: 24px;
  flex: 1 1 0%;
  overflow: auto;
  padding: 16px;
  font-size: 14px;
  font-weight: 400;
  text-align: center;
  font-style: italic;
  color: rgb(137, 123, 118);
  height: 62vh;
}
.model_bottom {
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: end;
  justify-content: flex-end;
  padding-inline-start: 24px;
  padding-inline-end: 24px;
  padding-top: 16px;
  padding-bottom: 16px;
  flex-direction: column;
  box-shadow: rgba(0, 0, 0, 0.05) 0px -4px 12px 0px;
}

.model_bottom_content {
  display: flex;
  width: 100%;
  justify-content: space-between;
}
.page_bottom_left {
  display: flex;
  gap: 8px;
  flex-flow: row;
}

.page_bottom_money {
  display: flex;
  gap: 0px;
  flex-flow: column;
  justify-content: space-around;
}

.page_bottom_money_top {
  font-size: 14px;
  font-weight: 400;
  text-align: left;
  color: rgb(137, 123, 118);
}

.page_bottom_money_bottom {
  font-size: 14px;
  font-weight: 500;
  text-align: left;
  color: #f05c22;
}
</style>
